import React from 'react'
import styled, { css } from 'styled-components'
import { string, node } from 'prop-types'
import { Link } from 'gatsby'
import { stripUnit } from 'polished'

import { fontSizes, fontWeights } from 'styles/typography'
import { white } from 'styles/colors'
import * as spacing from 'styles/spacing'
import { media } from 'styles/media'
import { animationTime, animationCurve, cover, square } from 'styles/global'

const Container = styled.div`
  display: block;
  position: relative;
  text-align: center;

  ${props =>
    !props.isClickable &&
    css`
      pointer-events: none;
    `}
`

const Inner = styled.div`
  background-color: #1e1e1e;
  border-radius: 14px;
  margin-top: 60px;
  padding-bottom: ${stripUnit(spacing.small) * 1.5 + 'px'};
  transition: background-color ${animationTime} ${animationCurve};

  ${Container}:hover &,
  ${Container}:focus & {
    background-color: #252525;
  }

  ${media.medium`
    padding-bottom: ${spacing.medium};
  `};

  ${media.large`
    margin-top: 90px;
  `};
`

const Content = styled.div`
  margin-top: -60px;

  ${media.large`
    margin-top: -90px;
  `};
`

const FigureWrap = styled.div`
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: 120%;
  top: -60px;
  margin-bottom: ${spacing.tiny};

  ${media.large`
    top: -90px;
    margin-bottom: ${spacing.small};
  `};

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`

const Name = styled.span`
  display: block;
  text-transform: uppercase;
  color: ${white};
  font-weight: ${fontWeights.medium};
  font-size: ${fontSizes.tiny};
  text-transform: uppercase;
  margin-bottom: ${spacing.small};

  ${media.small`
    font-size: ${fontSizes.small};
  `};

  ${media.medium`
    font-size: ${fontSizes.regular};
  `};

  ${media.large`
    font-size: 16px;
  `};
`

const Figure = styled.img`
  ${cover('absolute')};
`

const Footer = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 14px;

  ${media.medium`
    height: 18px;
  `};

  > * + * {
    margin-left: ${stripUnit(spacing.tiny) * 1.5 + 'px'};

    ${media.medium`
      margin-left: ${stripUnit(spacing.small) * 1.25 + 'px'};
    `};
  }
`

export const Color = styled.div`
  border-radius: 50%;
  background: ${props => props.color};
  ${square('10px')};

  ${media.medium`
    ${square('14px')};
  `};

  ${props =>
    props.isLarge &&
    css`
      ${square('28px')};

      ${media.medium`
        ${square('22px')};
      `};
    `}
`

export const Preview = styled.img`
  ${square('14px')};

  ${media.medium`
    ${square('18px')};
  `};

  ${props =>
    props.isLarge &&
    css`
      ${square('28px')};

      ${media.medium`
        ${square('22px')};
      `};
    `}

  ${props =>
    props.isCircle &&
    css`
      border-radius: 50%;
    `}
`

export const Plus = styled.div`
  color: ${white};
  text-transform: uppercase;
  font-size: ${fontSizes.mini};

  ${media.medium`
    font-size: ${fontSizes.tiny};
  `};
`

const Item = ({ link, name, figure, footer }) => (
  <Container isClickable={link} to={link} as={link ? Link : 'div'}>
    <Inner>
      <FigureWrap>
        <Figure src={`${process.env.BASE_PATH}/images/epod2/products/${figure}.png`} />
      </FigureWrap>
      <Content>
        <Name>{name}</Name>
        <Footer>{footer}</Footer>
      </Content>
    </Inner>
  </Container>
)

Item.propTypes = {
  link: string,
  name: string.isRequired,
  figure: string.isRequired,
  footer: node.isRequired
}

export default Item
